import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pluviometroDigital' };
/////////////////////////////////////////////////////////////////////////////////

export function createPluviometroDigital(payload) {
  return httpService.post(args, payload);
}

export function updatePluviometroDigital(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listPluviometroDigital(param) {
  return httpService.get({...args, args: param});
}

export function findPluviometroDigital(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deletePluviometroDigital(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

